var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_28601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1582 51.1117L15.8242 77.4372L73.2286 73.5415L77.6496 15.6582L60.1579 51.1113L60.1582 51.1117Z",
    fill: "url(#paint0_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3226 73.5011L68.3886 39.4473L54.9492 57.1936L73.3226 73.5014V73.5011Z",
    fill: "url(#paint1_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3929 73.5014L37.2463 70.6641L16.0195 77.3623L73.3929 73.5014Z",
    fill: "url(#paint2_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0675 77.3695L25.0976 47.7871L5.22656 52.0356L16.0672 77.3692L16.0675 77.3695Z",
    fill: "url(#paint3_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.946 57.291L46.6371 24.7461L22.8594 47.0349L54.946 57.2916V57.291Z",
    fill: "url(#paint4_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.767 25.2052L53.2902 6.84766L47.0312 27.0825L75.767 25.2052Z",
    fill: "url(#paint5_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2551 0.30092L52.0357 7.60664L43.6953 0.203125L65.2551 0.301225V0.30092Z",
    fill: "url(#paint6_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 61.9581L5.53778 51.8584L1.05808 39.8262L0 61.9581Z",
    fill: "url(#paint7_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.761719 39.4472L5.26884 52.2316L24.8532 47.8378L47.2121 27.058L53.5222 7.01538L43.5867 0L26.6949 6.32167C21.3728 11.2718 11.0458 21.0659 10.6735 21.2499C10.3049 21.4382 3.85401 33.631 0.761719 39.4472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5876 16.4808C28.122 5.04455 42.9915 -1.71217 48.6978 4.04527C54.401 9.80271 48.3529 23.7942 36.8185 35.2268C25.2841 46.6591 10.599 53.7881 4.89636 48.0307C-0.809897 42.2772 5.05326 27.9135 16.5876 16.4808Z",
    fill: "url(#paint8_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0703 77.3581L25.0297 47.6816L54.7842 57.2406C44.0261 67.3288 32.0606 75.8571 16.0703 77.3581Z",
    fill: "url(#paint9_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.25 27.0003L54.8887 57.2569C63.8755 47.8076 71.9411 37.649 75.8913 25.084L47.2503 27.0003H47.25Z",
    fill: "url(#paint10_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8131 25.2367C78.8704 16.011 79.5756 2.77574 65.1604 0.318359L53.332 6.85177L75.8131 25.2367Z",
    fill: "url(#paint11_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 61.825C0.423476 77.0516 11.4089 77.2786 16.0884 77.412L5.27913 52.168L0 61.825Z",
    fill: "#9E1209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.293 27.0474C54.1987 31.292 68.1164 39.8163 68.3985 39.9729C68.8372 40.2197 74.3988 30.5943 75.661 25.1543L47.293 27.0474Z",
    fill: "url(#paint12_radial_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0156 47.6816L36.9927 70.7894C44.0748 66.9486 49.6208 62.269 54.6998 57.2565L25.0156 47.6816Z",
    fill: "url(#paint13_radial_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23211 52.2004L3.53516 72.4078C6.73712 76.7817 11.1425 77.162 15.7629 76.8211C12.4199 68.5005 5.7415 51.8634 5.23211 52.2004Z",
    fill: "url(#paint14_linear_391_28601)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2617 6.90256L77.0556 10.2416C75.7854 4.86073 71.8858 1.38823 65.2388 0.302734L53.2617 6.90256Z",
    fill: "url(#paint15_linear_391_28601)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_391_28601",
    x1: 68.2212,
    y1: 84.4794,
    x2: 51.8585,
    y2: 55.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E42B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_391_28601",
    x1: 76.3819,
    y1: 60.1828,
    x2: 53.3803,
    y2: 55.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_391_28601",
    x1: 59.4936,
    y1: 85.3551,
    x2: 59.1973,
    y2: 70.7657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_391_28601",
    x1: 15.1645,
    y1: 49.9271,
    x2: 22.0035,
    y2: 69.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE3B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_391_28601",
    x1: 37.6751,
    y1: 30.0666,
    x2: 38.9155,
    y2: 51.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E4714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BE1A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_391_28601",
    x1: 57.6534,
    y1: 10.0031,
    x2: 59.4673,
    y2: 25.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_391_28601",
    x1: 46.6294,
    y1: 4.52278,
    x2: 49.1868,
    y2: -6.32122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C81F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_391_28601",
    x1: 1.52976,
    y1: 44.5038,
    x2: 8.21769,
    y2: 48.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DE4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF190B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF190B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_391_28601",
    x1: -7.27105,
    y1: 60.7897,
    x2: 52.8289,
    y2: -1.18611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C82F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#820C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_391_28601",
    x1: 38.831,
    y1: 67.0322,
    x2: 21.8231,
    y2: 59.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#990C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_391_28601",
    x1: 69.968,
    y1: 45.2738,
    x2: 52.4487,
    y2: 32.8298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E0C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_391_28601",
    x1: 75.8851,
    y1: 18.7883,
    x2: 67.6464,
    y2: 10.4249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E120B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_391_28601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.371 31.1147) scale(19.7365 10.313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7E0E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E0E08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_391_28601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0375 57.1235) scale(26.2366 20.424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#800E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800E08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_391_28601",
    x1: 10.4524,
    y1: 77.3408,
    x2: -4.31895,
    y2: 65.0793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9E100A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B3100C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3100C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_391_28601",
    x1: 60.6069,
    y1: 3.84088,
    x2: 64.7994,
    y2: 14.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#910F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#791C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791C12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_28601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77.688,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg11);
export default __webpack_public_path__ + "static/media/img11.3e330bd9fad596fa1d2a42c558951c75.svg";
export { ForwardRef as ReactComponent };